import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { showErrorToast, showErrorToastforLogin, showSuccessToast } from "../components/Constant/Notification";
import loginService from "../components/Services/LoginService"


const useLogin = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [formErrors, setFormErrors] = useState({
    email: false,
    password: false,
    general: "",
  });

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setFormErrors((prev) => ({ ...prev, email: false }));
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setFormErrors((prev) => ({ ...prev, password: false }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
  

    if (!validateEmail(email)) {
      showErrorToast("Email is not valid");
      return;
    }

    if (!email) {
      showErrorToast("Email is required");
      setFormErrors((prev) => ({ ...prev, email: true }));
      return;
    }

    if (!password) {
      showErrorToast("Password is required");
      setFormErrors((prev) => ({ ...prev, password: true }));
      return;
    }

    setIsLoading(true);
    setFormErrors({ email: false, password: false, general: "" });

    const loginData = {
      emailId: email.trim(),
      password: password.trim(),
    };

    try {
      const response = await loginService.loginUser(loginData);
      const userData = response.data;
      localStorage.setItem("userData", JSON.stringify(userData));

      const { role } = userData.user;
      let destination = "";

      switch (role) {
        case "Admin":
          destination = "/admin/dashboard";
          break;
        case "CMO":
          destination = "/cmo/dashboard";
          break;
        case "MD":
          destination = "/md/dashboard";
          break;
        case "BOD":
          destination = "/bod/dashboard";
          break;
        case "Lead Uploader":
          destination = "/lead-uploader";
          break;
        default:
          showErrorToastforLogin("Unauthorized login attempt!");
          setIsLoading(false);
          return;
      }

      navigate(destination);
      window.location.reload();

    } catch (error) {
      console.error("Login error:", error);
      showErrorToast(error.response)
      showErrorToastforLogin("Invalid credentials. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleForgotPassword = async (e) =>{

    e.preventDefault();
    
    setIsLoading(true)
   
    if (!email) {
     showErrorToast("Please enter your email address.");
      return;
      }

      try {
        const resetData = { email: email.trim() };
        const response = await loginService.resetPassword(resetData);
        if (response.status === 200) {
          setFormErrors((prev) =>
            prev ? { ...prev, email: "" } : { email: "" }
          );
          showSuccessToast("Password reset link sent to your email!");
          setIsLoading(false);
          } 
          } catch (error) {
            console.error("Forgot password error:", error);
            showErrorToast(error?.response?.data)
            
          }finally{
            setIsLoading(false);
          }
  }

  return {
    email,
    password,
    isLoading,
    formErrors,
    handleEmailChange,
    handlePasswordChange,
    handleLogin,
    navigate,
    handleForgotPassword,
  };
};

export default useLogin;

